import { atom, atomFamily } from 'recoil'

export const pageState = atom({
  key: 'SourcesListPageState',
  default: {
    loaded: false,
    loading: false,
    fetching: false,
    fetchingLoaded: false,
    isEmptyState: false,
    error: false,
    severity: 'danger',
    items: [],
    totalItems: 0,
    pageSize: 10,
    pageNumber: 1,
    orderBy: 'UpdateDate',
    orderDescending: true
  }
})

export const moreResults = atomFamily({
  key: 'SourcesListMoreResults',
  default: {
    moreLoaded: false,
    moreLoading: false,
    moreLastContentUpdates: [],
    moreContentsNumber: [],
    moreShared: false,
    error: false,
    severity: 'danger'
  }
})
